import PricebookItemEditor from "./PricebookItemEditor";

export default PricebookItemEditor;



// WEBPACK FOOTER //
// ./src/components/Pricebook/PricebookItemEditor/index.js